/**
 * @Author: Nenad Brcic
 * @Date: 31.05.16
 * @Email: neno@neno.ch
 */
import Relay from 'react-relay'
import Location from './Location'


const LocationContainer = Relay.createContainer(Location, {
    initialVariables: {
        isLocationContainerVisible: false
    },
    fragments: {
        object: () => Relay.QL`
            fragment on Object {
                ObjObjectNumberTxt,
                ObjFloorplan,
                ObjFloorplanCaption,
            }
        `,
    },
});

export default LocationContainer;


// WEBPACK FOOTER //
// ./app/components/Object/Detail/Location/index.js